exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".EditorMedia{position:relative;margin-bottom:10px}.EditorMedia .block-spinner{position:absolute;width:100%;height:100%;z-index:99;background:hsla(0,0%,100%,.7)}.EditorMedia .actions{display:flex;justify-content:space-between;font-size:22px;align-items:center}.EditorMedia .actions .title{font-size:14px;color:rgba(0,0,0,.65);font-weight:700}.EditorMedia .actions label+label{margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/helpers/Fields/EditorMedia/EditorMedia.scss
// module id = 4533
// module chunks = 0